import React from "react";
import { ShoppingBag } from "lucide-react";
import "../../styles/sectionPage.css";

/**
 * Presentational component to show when no products belong to the selected category.
 * @param {Object} props
 * @param {string} props.sectionColor - Section theme accent color
 */
const EmptyProductsState = ({ sectionColor }) => {
  const accentStyle = {
    "--section-color": sectionColor || "#ff6a00",
  };

  return (
    <div className="empty-products-container" style={accentStyle}>
      <div className="empty-products-icon-wrapper">
        <ShoppingBag size={48} strokeWidth={1.5} className="empty-products-icon" />
      </div>
      <h3 className="empty-products-title">No Products Found</h3>
      <p className="empty-products-subtitle">
        There are currently no products available in this category. Please check back later.
      </p>
    </div>
  );
};

export default EmptyProductsState;
